module.exports = __webpack_public_path__ + "static/media/YM26_2.cb45adef.jpg";